export default __webpack_public_path__ + "static/media/QaModalcross.f0e9bdd9.svg";